import { render, staticRenderFns } from "./UploadImage1.vue?vue&type=template&id=515d2baa&scoped=true&"
import script from "./UploadImage1.vue?vue&type=script&lang=js&"
export * from "./UploadImage1.vue?vue&type=script&lang=js&"
import style0 from "./UploadImage1.vue?vue&type=style&index=0&id=515d2baa&prod&lang=less&scoped=true&"
import style1 from "./UploadImage1.vue?vue&type=style&index=1&id=515d2baa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515d2baa",
  null
  
)

export default component.exports